<template>
  <label class="textarea">
    <div v-if="placeholder" class="textarea__placeholder text-h5">
      {{ placeholder }}
    </div>
    <textarea
      v-model="value"
      class="text-body"
      :class="inputClass"
      :disabled="disabled"
      rows="3"
    />
  </label>
</template>

<script lang="ts">
import type { PropType } from "vue";

import { ref, computed } from "vue";
import BaseIcon from "~/components/icons/BaseIcon.vue";

export default defineNuxtComponent({
  components: { BaseIcon },
  props: {
    modelValue: {
      type: [Number, String] as PropType<number | string>,
      default: "",
    },
    error: {
      type: String as PropType<string | null>,
      default: null,
    },
    upperCase: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    icon: {
      type: String as PropType<string>,
      default: null,
    },
    placeholder: {
      type: String as PropType<string | null>,
      default: null,
      required: false,
    },
    validator: {
      type: Function,
      required: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    clearable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ["change", "update:modelValue"],

  setup(props, { emit }) {
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(val) {
        emit("update:modelValue", val);
      },
    });

    const validatorErrorMessage = ref(null);

    watch(
      () => props.modelValue,
      () => {
        if (props.validator) {
          validatorErrorMessage.value = props.validator(props.modelValue);
        }
      }
    );

    const isFocus = ref(false);
    const inputClass = computed(() => ({
      "upper-case": props.upperCase,
      "input-error-text": validatorErrorMessage.value,
    }));

    return {
      value,
      isFocus,
      inputClass,
      validatorErrorMessage,
    };
  },
});
</script>
